import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function useGetDistributorCompany(params: { mac: string }) {
  return useQuery({
    ...queries.devices.distributorCompany(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
